import { count } from "sms-length";

function remainingChars(msg: string) {
  const result = count(msg);
  return (
    result.characterPerMessage -
    (result.characterPerMessage * (result.messages - 1) +
      result.inCurrentMessage)
  );
}

function remainingSenderChars(msg: string) {
  if (msg.length === 0) {
    return 11;
  }
  const legalCharsRegex = /^(?=.*[a-zA-Z\s])[a-zA-Z0-9\s]+$/;
  if (!legalCharsRegex.test(msg)) {
    return -1;
  }
  return 11 - msg.length;
}

export { remainingChars, remainingSenderChars };
